import React from "react";

export default function onChange(handler) {
  return Component =>
    class extends React.Component {
      componentWillReceiveProps(nextProps) {
        handler(this.props, nextProps);
      }

      render() {
        return <Component {...this.props} />;
      }
    };
}



// WEBPACK FOOTER //
// ./app/modules/shared/decorators/onChange.jsx